/** AUTO-GENERATED from policy-library/care-type-license-map.json — do not edit by hand. */
/** Run: npm run policy-library:catalog */

export type CareTypePolicyClass =
  | "license_primary"
  | "license_alias"
  | "service_tag"
  | "deferred_pack"
  | "invalid";

export type CareTypeLicenseMapEntry = {
  key: string;
  class: CareTypePolicyClass;
  licenseFamily: string | null;
  notes: string;
};

export const CARE_TYPE_LICENSE_MAP_VERSION = 1 as const;

export const KNOWN_POLICY_LICENSE_FAMILIES = [
  "assisted_living",
  "home_care",
  "group_home",
  "hospice",
  "nursing_home",
  "adult_day_care",
  "independent_living",
  "rehabilitation",
  "foster_care"
] as const;

export const CARE_TYPE_LICENSE_MAP: CareTypeLicenseMapEntry[] = [
  {
    "key": "assisted_living",
    "class": "license_primary",
    "licenseFamily": "assisted_living",
    "notes": "MDH assisted living facility license (Minn. Stat. ch. 144G)."
  },
  {
    "key": "memory_care",
    "class": "license_alias",
    "licenseFamily": "assisted_living",
    "notes": "144G Assisted Living Facility with Dementia Care category (144G.80); not a separate home-care pack."
  },
  {
    "key": "home_care",
    "class": "license_primary",
    "licenseFamily": "home_care",
    "notes": "MDH home care provider license basic or comprehensive (144A.471+)."
  },
  {
    "key": "home_health",
    "class": "license_alias",
    "licenseFamily": "home_care",
    "notes": "Distinct search/storage key from home_care (clinical HHA). Policy manuals still share the home_care license family."
  },
  {
    "key": "group_home",
    "class": "license_primary",
    "licenseFamily": "group_home",
    "notes": "DHS 245D / community residential — not MDH 144G. state_mvp pack via group-home-245d-rules.yaml."
  },
  {
    "key": "foster_care_agency",
    "class": "deferred_pack",
    "licenseFamily": "foster_care",
    "notes": "NPPES candidate-only organization type. Requires authoritative foster-care agency evidence and a state-specific license policy before promotion or policy-pack access."
  },
  {
    "key": "hospice",
    "class": "license_primary",
    "licenseFamily": "hospice",
    "notes": "MDH hospice license 144A.75–144A.755. state_mvp pack via hospice-rules.yaml. Medicare 418 CoPs deferred (P2b). Do not fold into home_care."
  },
  {
    "key": "nursing_home",
    "class": "deferred_pack",
    "licenseFamily": "nursing_home",
    "notes": "MDH nursing home 144A.01–144A.10 / Minn. R. 4658. Not assisted living."
  },
  {
    "key": "skilled_nursing",
    "class": "deferred_pack",
    "licenseFamily": "nursing_home",
    "notes": "Treat as nursing-home policy family; pack deferred."
  },
  {
    "key": "adult_day_care",
    "class": "deferred_pack",
    "licenseFamily": "adult_day_care",
    "notes": "DHS adult day (Minn. R. 9555.9600–.9730). No AL/HC manuals."
  },
  {
    "key": "independent_living",
    "class": "deferred_pack",
    "licenseFamily": "independent_living",
    "notes": "Housing without AL services is generally not 144G; no policy pack."
  },
  {
    "key": "rehabilitation",
    "class": "deferred_pack",
    "licenseFamily": "rehabilitation",
    "notes": "No matching shipped policy pack; fail closed."
  },
  {
    "key": "palliative_care",
    "class": "service_tag",
    "licenseFamily": null,
    "notes": "Service/need label; hospice-adjacent under statute but not a standalone facility pack key."
  },
  {
    "key": "respite_care",
    "class": "service_tag",
    "licenseFamily": null,
    "notes": "Service/setting-dependent (incl. 245D). Must not be sole business_type for Policies."
  },
  {
    "key": "chronic_disease_management",
    "class": "service_tag",
    "licenseFamily": null,
    "notes": "Search specialty only."
  },
  {
    "key": "wound_care",
    "class": "service_tag",
    "licenseFamily": null,
    "notes": "Search specialty only."
  },
  {
    "key": "post_surgery_care",
    "class": "service_tag",
    "licenseFamily": null,
    "notes": "Search specialty only."
  },
  {
    "key": "other",
    "class": "invalid",
    "licenseFamily": null,
    "notes": "Not a licensed facility type for Policies."
  }
];

export const CARE_TYPE_LICENSE_MAP_BY_KEY: Record<string, CareTypeLicenseMapEntry> =
  Object.fromEntries(CARE_TYPE_LICENSE_MAP.map((e) => [e.key, e]));

/** Normalize business_type / Care Type tokens for map lookup (exact key match after normalize). */
export function normalizeCareTypeKey(raw?: string | null): string {
  return (raw || "")
    .trim()
    .toLowerCase()
    .replace(/[-\s]+/g, "_");
}

export function lookupCareTypeLicenseEntry(
  raw?: string | null
): CareTypeLicenseMapEntry | undefined {
  const key = normalizeCareTypeKey(raw);
  if (!key) return undefined;
  return CARE_TYPE_LICENSE_MAP_BY_KEY[key];
}

/** Mapped license family from the Care Type matrix (drives packAccess). */
export function resolveMappedLicenseFamily(
  raw?: string | null
): string | null {
  const entry = lookupCareTypeLicenseEntry(raw);
  if (!entry) return null;
  return entry.licenseFamily;
}
